<script lang="ts">
	import { _ } from 'utils/i18/i18n';
	import EmptyTable from 'components/EmptyTable/EmptyTable.svelte';
	import SortingArrow from 'components/SortingArrow/SortingArrow.svelte';
	import TopMarketsTableRow from './TopMarketsTableRow/TopMarketsTableRow.svelte';
	import type { ITopMarket } from 'customTypes/exchange';
	import CustomButton from '../CustomButton/CustomButton.svelte';
	import activeLocale from 'stores/activeLocale';

	export let dark = false;
	export let tableData: ITopMarket[] = [];
	export let coingeckoId: string;
	export let exchangeType: 'spot' | 'derivative';
	let sortBy: string;
	let isPressed = false;
	$: normalizedLocale = $activeLocale.locale === 'en' ? '' : `/${$activeLocale.locale}/`;

	function handleFilterClick(
		e: Event & { currentTarget: HTMLElement },
		direction: 'asc' | 'desc',
		property: string,
	) {
		sortBy = e.currentTarget.id;
		tableData = tableData.sort(function (a, b) {
			return direction === 'desc'
				? a[property].localeCompare(b[property])
				: b[property].localeCompare(a[property]);
		});
	}
</script>

<div class="wrapper">
	<table class="table" class:dark>
		<thead class="table-head no-select">
			<tr class="table-row">
				<th
					id="base"
					class="head-cell name clickable"
					on:click={(e) => {
						if (sortBy !== 'base') isPressed = true;
						handleFilterClick(e, isPressed ? 'asc' : 'desc', 'base');
						isPressed = !isPressed;
					}}
				>
					{$_('exchanges.name')}
					<SortingArrow {isPressed} pressedIconId={sortBy} idToCompare={'base'} width={11} height={7} />
				</th>
				<th id="price" class="head-cell price">{$_('general.price')} </th>
				<th id="price" class="head-cell volume">{$_('general.volume')} </th>
			</tr>
		</thead>

		{#key tableData}
			<tbody class="table-body">
				{#if !tableData || tableData?.length === 0}
					<EmptyTable
						{dark}
						colAmountFromTabletView={3}
						colAmountMobView={3}
						tableType="exchange-top-markets"
						withNoDataText={tableData?.length === 0}
					/>
				{:else}
					{#each tableData as market}
						<TopMarketsTableRow data={market} {dark} />
					{/each}
				{/if}
			</tbody>
		{/key}
	</table>
	<div class="btn-wrapper">
		<CustomButton
			component="link"
			onClick={null}
			title="View all markets"
			linkTo={exchangeType === 'spot'
				? `/markets/${coingeckoId}${normalizedLocale}`
				: `/markets/${coingeckoId}${normalizedLocale}?type=derivative`}
		/>
	</div>
</div>

<style lang="scss">
	@import 'topMarketsTable';
</style>
